import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';

interface RequireUserProps {
  children: React.ReactNode;
}

export const RequireUser: React.FC<RequireUserProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  console.log('🔒 RequireUser check:', { hasUser: !!user, loading });
  
  // Show loading while auth state is being determined
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <LoadingSpinner size="lg" />
      </div>
    );
  }
  
  // User is authenticated
  if (user) {
    return <>{children}</>;
  }
  
  // User is not authenticated - redirect to auth
  console.log('🔒 No user found, redirecting to auth');
  return <Navigate to="/auth" replace state={{ from: location }} />;
};
